import styles from "./RadioButton.module.css";
import React from "react";

type RadioButtonProps = {
  checked: boolean;
  color?: string;
  onCheck?: (value: boolean) => void;
};

const RadioButton: React.FC<RadioButtonProps> = ({
  checked,
  color = "#000",
  onCheck,
}) => {
  return (
    <div
      className={styles.outsideCircle}
      style={{ borderColor: color }}
      onClick={() => onCheck && onCheck(!checked)}
    >
      {checked && (
        <div
          className={styles.insideCircle}
          style={{ backgroundColor: color }}
        />
      )}
    </div>
  );
};

export default RadioButton;
